import { ComponentType } from "react";

import { useClientTranslations } from "@/common/helpers/clientTranslations/useClientTranslations";
import { MyAppProps } from "@/common/types/page";

import { ClientTranslationsLoadError } from "./ClientTranslationsLoadError";
import { ClientTranslationsLoading } from "./ClientTranslationsLoading";

const PAGE_BY_STATUS = {
  loading: ClientTranslationsLoading,
  failed: ClientTranslationsLoadError,
} as const;

export const withClientTranslations = (App: ComponentType<MyAppProps>) =>
  function AppWithClientTranslations(props: MyAppProps) {
    const clientTranslations = useClientTranslations(props.Component.translationNamespaces);

    switch (clientTranslations.status) {
      case "fromServer":
        return <App {...props} />;
      case "ready":
        return <App {...props} pageProps={{ ...props.pageProps, _nextI18Next: clientTranslations.nextI18Next }} />;
      case "loading":
      case "failed":
        return <App {...props} Component={PAGE_BY_STATUS[clientTranslations.status]} />;
    }
  };
